import styled from 'styled-components';

export const TabContainer = styled.div`
	margin-bottom: ${({ marginBottom }) => `${marginBottom}rem`};
`;

export const TabInput = styled.input``;

export const TabLabel = styled.label`
	&& {
		${TabInput} + & {
			position: relative;
			transition: color 100ms ease-in-out;
			border-radius: 0;
			background-color: transparent;
			padding-right: 0;
			padding-left: 0;
			color: ${({ theme }) => theme['silver-base']};

			&::after {
				position: absolute;
				bottom: 0.125rem;
				left: 0;
				transition: opacity 100ms ease-in-out;
				background-color: ${({ theme }) => theme['blue-base']};
				opacity: 0;
				width: 100%;
				height: 0.125rem;
				content: '';
			}

			&:hover {
				color: ${({ theme }) => theme['white']};
				background-color: transparent;
			}

			&:not(:last-child) {
				margin-right: 1.5rem;
			}
		}

		${TabInput}:checked + &,
		${TabInput}:checked + &:active,
		${TabInput}:checked + &:hover {
			background-color: transparent;
			color: ${({ theme }) => theme['white']};

			&:after {
				opacity: 1;
			}
		}
	}
`;
